module.exports = __webpack_public_path__ + "static/media/GZ2@2x.9a5f3d1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/GZ/GZ2@2x.png
// module id = 645
// module chunks = 0